import React, { useEffect, useRef, useState } from 'react';
import QrScanner from 'qr-scanner';
import { Camera } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { uiText } from '../lib/i18n';

export const QRReader = ({ onRead, busy, prefix }) => {
  const [camera, setCamera] = useState(false);
  const [raw, setRaw] = useState('');
  const [error, setError] = useState('');
  const video = useRef(null);
  const callback = useRef(onRead);
  callback.current = onRead;
  useEffect(() => {
    if (!camera || !video.current) return;
    let read = false;
    const scanner = new QrScanner(video.current, result => {
      if (read) return;
      read = true; scanner.stop(); setCamera(false); callback.current(result.data);
    }, { preferredCamera: 'environment', highlightScanRegion: true, returnDetailedScanResult: true });
    scanner.start().catch(() => { setError('Camera access is unavailable. Allow camera access or use the scanner input below.'); setCamera(false); });
    return () => scanner.destroy();
  }, [camera]);
  return <div className="space-y-5" data-testid={`${prefix}-reader`}>
    {error && <p data-testid={`${prefix}-camera-error`} role="alert" className="text-sm text-rose-600">{uiText(error)}</p>}
    {camera && <video ref={video} data-testid={`${prefix}-qr-camera`} className="merchant-camera" playsInline muted />}
    <Button data-testid={`${prefix}-open-camera`} variant="outline" className="customer-secondary" disabled={busy} onClick={() => { setError(''); setCamera(value => !value); }}><Camera size={18} className="mr-2" />{camera ? 'Stop camera' : 'Open camera'}</Button>
    <form data-testid={`${prefix}-scanner-input-form`} className="space-y-3" onSubmit={event => { event.preventDefault(); setCamera(false); onRead(raw); }}>
      <Label htmlFor={`${prefix}-scanner-input`}>Scanner input</Label><Input id={`${prefix}-scanner-input`} data-testid={`${prefix}-scanner-input`} value={raw} onChange={event => setRaw(event.target.value)} autoComplete="off" placeholder="Scan or paste the MALDHOWR QR code" required disabled={busy} />
      <Button data-testid={`${prefix}-inspect-qr`} type="submit" className="customer-primary bg-emerald-600 hover:bg-emerald-700" disabled={busy}>Read QR code</Button>
    </form>
  </div>;
};